var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-box"},[_c('div',{staticClass:"search-input"},[_c('img',{attrs:{"src":"/images/icons/search.svg"}}),_c('input',{attrs:{"spellcheck":"false"},domProps:{"value":this.query},on:{"input":_vm.handleSearch}})])])}
var staticRenderFns = []

export { render, staticRenderFns }